<template>
  <div class="steps-item-component">
    <span href="#" class="steps-marker"></span>
    <div
      class="steps-content"
      :class="{ 'is-fullwidth': fullWidth }"
    >
      <div class="columns">
        <div
            class="column is-truncate-text"
            :class="{
              'is-8': price,
              'is-12': !price
             }"
        >
          <span class="is-size-5 has-text-weight-bold has-text-grey-dark is-no-wrap" v-if="name">
            {{ name }}
            <span class="has-text-weight-bold is-4 has-text-grey" v-if="price">
              ...........................................
            </span>
          </span>
        </div>
        <div class="column is-4" v-if="price">
          <span class="is-pulled-right">
            <span class="is-size-6 has-text-weight-light has-text-grey-secondary">R$ </span>
            <span class="is-size-6 has-text-weight-light has-text-grey-secondary">{{ formatPrice(price) }}</span>
            <span class="is-size-6 has-text-weight-light has-text-grey-secondary" v-if="unit">/{{ unit }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'item',

  props: {
    name: {
      required: false,
      type: String
    },
    price: {
      required: false,
      type: String
    },
    unit: {
      required: false,
      type: String
    },
    fullWidth: {
      required: true,
      type: Boolean
    }
  },

  methods: {
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    }
  }

}

</script>

<style lang="scss" scoped>
.steps-item-component {
  .is-no-wrap {
    white-space: nowrap;
  }

  .is-fullwidth {
    width: 100%!important;
  }

  .steps-content {
    width: 30%;
    padding-right: calc(0.25rem + 2em);
  }
}
</style>